import { Component } from '@angular/core';
import {NavParams ,ViewController} from 'ionic-angular';
/**
 * Generated class for the SchFilterComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'sch-filter',
  templateUrl: 'sch-filter.html'
})
export class SchFilterComponent {

  tabIndex: number=0;
  startStaions:any[]=[];
  endStations:any[]=[];
  constructor(
    public navParams:NavParams,
    public viewController:ViewController,
  ) {
    //this.startStaions=[{name:'北京东路'},{name:'山西'},{name:'哈尔滨'},{name:'黑龙江'},{name:'芜湖'},{name:'保定'}];
  }

  ionViewDidLoad() {
    console.log(this.navParams.data);
    this.startStaions=this.navParams.get('startStaions');
    this.endStations=this.navParams.get('endStations');
    this.tabIndex=this.navParams.get('tabIndex');
  }


  closeFilter(){
      this.viewController.dismiss();
  }

  clearFilter(){
    this.startStaions.forEach(x=>{
      x.selected=false;
    });
    this.endStations.forEach(x=>{
      x.selected=false;
    });
  }

  sureFilter(){
    this.viewController.dismiss({
      startStaions:this.startStaions.filter(x=>x.selected).map(x=>x.name),
      endStations:this.endStations.filter(x=>x.selected).map(x=>x.name),
      tabIndex:this.tabIndex
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/sch-filter/sch-filter.ts